<template>
    <div class="msg">
        <div class="getPwd-way-choice" v-show="getPwdChoice">
            <button type="button" class="getPwd-way" v-show="false" :title="findPhoneNum" @click="phoneShow" v-text="findPhoneNum"></button>
            <button type="button" class="getPwd-way" :title="findEmile" @click="emileShow" v-text="findEmile"></button>
            <button type="button" class="getPwd-way" :title="cancle" v-text="cancle" @click="getPwdClose"></button>
        </div>
        <div class="getPwd-way-phone" v-show="getPwdPhone">
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="phoneNum" v-text="phoneNum"></span>
                <input type="text" name="" style="width:160px;" maxlength="32" v-model="phoneVal" @input="limitphoneUserName($event)" class="fr phone-list-input">
                <button type="button" class="fr" @click="phoneOpen" v-text="phoneText" style="width:60px;height:100%;border:none;box-sizing:border-box;outline:none;"></button>
            </div>
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="code" v-text="code"></span>
                <button type="button" class="fr code-btn" :title="getCode" @click="getCodeNum" v-text="getCode" :disabled="vercodeDisable"></button>
                <div class="fr count" v-text="count"></div>
                <input type="text" name="" v-model="phoneCode" @input="limitVercode($event)" class="fr phone-list-input" style="width:80px;">
            </div>
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="setPwd" v-text="setPwd"></span>
                <input type="password" name="" maxlength="32" v-model="phonePwd"  class="fr phone-list-input">
            </div>
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="confirmPwd" v-text="confirmPwd"></span>
                <input type="password" name="" maxlength="32" v-model="phonePwdCon" class="fr phone-list-input">
            </div>
            <div class="cle phone-list confirm-btn">
                <button type="button" class="fl" :title="confirm" v-text="confirm" @click="pwdPhone"></button>
                <button type="button" class="fr" :title="cancle" v-text="cancle" @click="getPwdClose"></button>
            </div>
        </div>
        <div class="getPwd-way-phone getPwd-way-emile" v-show="getPwdEmile">
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="emileNum" v-text="emileNum"></span>
                <input type="text" name="" maxlength="32" v-model="emilePwd" class="fl phone-list-input">
            </div>
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="code" v-text="code"></span>
                <div class="fl cle" style="width:220px;height:100%;">
                    <button type="button" class="fr code-btn" :title="getCodes" @click="getCodeNums" v-text="getCodes" :disabled="vercodeDisables"></button>
                    <div class="fr count" v-text="counts"></div>
                    <input type="text" name="" v-model="phoneCodes" @input="limitVercode($event)" class="fr phone-list-input" style="width:80px;">
                </div>
            </div>
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="setPwd" v-text="setPwd"></span>
                <input type="password" name="" maxlength="32" v-model="phonePwds"  class="fl phone-list-input">
            </div>
            <div class="cle phone-list">
                <span class="fl phone-list-title" :title="confirmPwd" v-text="confirmPwd"></span>
                <input type="password" name="" maxlength="32" v-model="phonePwdCons" class="fl phone-list-input">
            </div>
            <div class="cle phone-list confirm-btn">
                <button type="button" class="fl" :title="confirm" v-text="confirm" @click="pwdEmile"></button>
                <button type="button" class="fr" :title="cancle" v-text="cancle" @click="getPwdClose"></button>
            </div>
        </div>
        <PhonePre v-show="phonePreShow" v-on:show="phoneSH" ref="phonePreL"></PhonePre>
    </div>
</template>
<script>
import forget from '../assets/js/login'
import PhonePre from './PhonePre'
export default {
    name:'GetPwd',
    components:{
        PhonePre:PhonePre
    },
    data(){
        return{
            lan:'',
            getPwdChoice:true,
            getPwdPhone:false,
            getPwdEmile:false,
            findPhoneNum:'',
            findEmile:'',
            cancle:'',
            phoneNum:'',
            phoneVal:'',
            phoneCode:'',
            phoneCodes:'',
            phonePwd:'',
            phonePwds:'',
            phonePwdCon:'',
            phonePwdCons:'',
            emilePwd:'',
            code:'',
            getCode:'',
            getCodes:'',
            setPwd:'',
            confirmPwd:'',
            confirm:'',
            vercodeDisable:false,
            vercodeDisables:false,
            pwdCheck:/^(?!\d+$)(?![a-zA-Z]+$)\S{6,20}$/,
            emileNum:'',
            emilecheck:/.+@.+/,
            startTime:121,
            startTimes:121,
            time:'',
            times:'',
            count:'',
            counts:'',
            phonePreShow:false,
            phoneText:'+86'
        }
    },
    methods:{
        phoneShow:function(){
            this.getPwdChoice=false;
            this.getPwdPhone=true;
        },
        emileShow:function(){
            this.getPwdChoice=false;
            this.getPwdEmile=true;
        },
        getPwdClose:function(){
            this.$emit("getPwdOpen",false);
            this.getPwdChoice=true;
            this.getPwdPhone=false;
            this.getPwdEmile=false;
            clearTimeout(this.time);
            clearTimeout(this.times);
            this.phoneText='+86';
            this.phoneVal='';
            this.phoneCode='';
            this.phoneCodes='';
            this.count='';
            this.counts='';
            this.phonePwd='';
            this.phonePwds='';
            this.phonePwdCon='';
            this.phonePwdCons='';
            this.emilePwd='';
            this.startTime=121;
            this.startTimes=121;
            this.vercodeDisable = false;
            this.vercodeDisables = false;
            this.getCode = this.lan['K017_GetVerCode'];
            this.getCodes = this.lan['K017_GetVerCode'];
        },
        pwdPhone:function(){
            if(this.phonePwd!==this.phonePwdCon){
                alert(this.lan['K114_PwdNoSame']);
                return false;
            };
            if(!this.pwdCheck.test(this.phonePwdCon)){
                alert(this.lan['K113_LimitPwd']);
                return;
            };
            var oem=this.baseData.oem;
            var xml=forget.getPwdByPhone({
                oem:oem,
                val:this.phoneText+this.phoneVal,
                code:this.phoneCode,
                pwd:this.hashEncryption(this.phonePwdCon)
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:xml
            });
            this.pwdPhoneResult(data.data);
        },
        pwdPhoneResult:function(data){
            var result = $(data).find('header').find('result').text();
            if(result === "0"){
                alert(this.lan['K158_Send']);
                this.getPwdClose();
            }else if(result === "100101000"){
                var redirectId=$(data).find('redirect-region-id').text();
                this.$emit('changeSend',{id:redirectId,type:'linkPhone'});
            }else{
                var key = this.promptInfo(result);
                alert(this.lan[key] == undefined ? key : this.lan[key]);
            };
        },
        limitphoneUserName:function(event){
            var reg=/\d+/;
            if(reg.exec(this.phoneVal)===null){
                this.phoneVal ='';
            }else{
                this.phoneVal =reg.exec(this.phoneVal);
            };
        },
        limitVercode:function(event){
            // this.phoneCode = event.target.value.replace(/[^\d]/g,'');
        },
        getCodeNum:function(){
            if(this.phoneVal===''){
                alert(this.lan['K155_Mobile']);
                return false;
            };
            var oem=this.baseData.oem;
            var xml=forget.getPwdByPhoneCode({
                oem:oem,
                phone:this.phoneText+this.phoneVal,
                type:'auth-mobile',
                app:this.baseData.appID
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:xml
            });
            this.getCodeNumResult(data.data);
        },
        getCodeNumResult:function(data){
            var result = $(data).find('header').find('result').text();
            if(result === "0"){
                this.vercodeDisable=true;
                this.getCode = this.lan['K111_SendSuccess'];
                clearTimeout(this.time);
                this.time=setInterval(function(){
                    this.startTime--;
                    this.count=this.startTime+'s';
                    if(this.startTime===0){
                        clearTimeout(this.time);
                        this.startTime=121;
                        this.count='';
                        this.vercodeDisable = false;
                        this.getCode = this.lan['K017_GetVerCode'];
                    };
                }.bind(this),1000)
            }else if(result === "100101000"){
                var redirectId=$(data).find('redirect-region-id').text();
                this.$emit('changeSend',{id:redirectId,type:'Phonecode'});
            }else{
                var key = this.promptInfo(result);
                alert(this.lan[key] == undefined ? key : this.lan[key]);
            };
        },
        getCodeNums:function(){
            if(this.emilePwd===''){
                alert(this.lan['K148_emailEmpty']);
                return false;
            };
            var oem=this.baseData.oem;
            var xml=forget.getPwdByPhoneCode({
                oem:oem,
                phone:this.emilePwd,
                type:'auth-email',
                app:this.baseData.appID
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:xml
            });
            this.getCodeNumResults(data.data);
        },
        getCodeNumResults:function(data){
            var result = $(data).find('header').find('result').text();
            if(result === "0"){
                this.vercodeDisables=true;
                this.getCodes = this.lan['K111_SendSuccess'];
                clearTimeout(this.times);
                this.times=setInterval(function(){
                    this.startTimes--;
                    this.counts=this.startTimes+'s';
                    if(this.startTimes===0){
                        clearTimeout(this.times);
                        this.startTimes=121;
                        this.counts='';
                        this.vercodeDisables = false;
                        this.getCodes = this.lan['K017_GetVerCode'];
                    };
                }.bind(this),1000)
            }else if(result === "100101000"){
                var redirectId=$(data).find('redirect-region-id').text();
                this.$emit('changeSend',{id:redirectId,type:'Emilecode'});
            }else{
                var key = this.promptInfo(result);
                alert(this.lan[key] == undefined ? key : this.lan[key]);
            };
        },
        pwdEmile:function(){
            if(!this.reg.user.limit.test(this.emilePwd)){
                alert(this.lan['K201_Type']);
                return;
            };
            if(this.emilePwd.indexOf('@')===-1){
                alert(this.lan['K123_EmailCheck']);
                return;
            };
            if(this.phoneCodes===''){
                alert(this.lang['K156_Verification']);
                return false;
            };
            if(this.phonePwds!==this.phonePwdCons){
                alert(this.lan['K114_PwdNoSame']);
                return false;
            };
            if(!this.pwdCheck.test(this.phonePwdCons)){
                alert(this.lan['K113_LimitPwd']);
                return;
            };
            var oem=this.baseData.oem;
            var xml=forget.getPwdByEmails({
                oem:oem,
                email:this.emilePwd,
                code:this.phoneCodes,
                pwd:this.hashEncryption(this.phonePwdCons)
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:xml
            });
            this.pwdEmileResults(data.data);
        },
        pwdEmileResults:function(data){
            var result = $(data).find('header').find('result').text();
            if(result === "0"){
                alert(this.lan['K158_Send']);
                this.getPwdClose();
            }else if(result === "100101000"){
                var redirectId=$(data).find('redirect-region-id').text();
                this.$emit('changeSend',{id:redirectId,type:'codeEmile'});
            }else{
                var key = this.promptInfo(result);
                alert(this.lan[key] == undefined ? key : this.lan[key]);
            };
        },
        pwdEmileResult:function(data){
            var result = $(data).find('header').find('result').text();
            if(result === "0"){
                alert(this.lan['K158_Send']);
                this.getPwdClose();
            }else if(result === "100101000"){
                var redirectId=$(data).find('redirect-region-id').text();
                this.$emit('changeSend',{id:redirectId,type:'linkEmile'});
            }else{
                var key = this.promptInfo(result);
                alert(this.lan[key] == undefined ? key : this.lan[key]);
            };
        },
        lang:function(lan){
            this.lan=this.lanSave[lan];
            this.findPhoneNum = this.lan['K120_FindPhone'];
            this.findEmile = this.lan['K121_FindEmile'];
            this.cancle = this.lan['K018_Cancel'];
            this.phoneNum = this.lan['K015_Phone'];
            this.code = this.lan['K016_VerCode'];
            this.getCode = this.lan['K017_GetVerCode'];
            this.getCodes = this.lan['K017_GetVerCode'];
            this.setPwd = this.lan['K003_Password'];
            this.confirmPwd = this.lan['K014_ConfirmPwd'];
            this.confirm = this.lan['K024_Confirm'];
            this.emileNum = this.lan['K013_Email'];
            this.$refs.phonePreL.lang(lan);
        },
        phoneOpen:function(){
            this.phonePreShow=true;
            this.$refs.phonePreL.select(this.phoneText);
        },
        phoneSH:function(show){
            this.phonePreShow=false;
            if(show.show){
                this.phoneText=show.num;
            };
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .getPwd-way-choice{
        width:400px;
        height:170px;
        background-color: #ffffff !important;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-85px;
        margin-left:-200px;
        padding:20px;
        box-sizing:border-box;
    }
    .getPwd-way{
        width:100%;
        height:30px;
        color:#fff;
        background-color:#0C5297;
        border:none;
        border-radius: 5px;
        outline: none;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .getPwd-way:hover{
        background-color:#0193FF;
    }
    .getPwd-way+.getPwd-way{
        margin-top:20px;
    }
    .getPwd-way-phone{
        width:400px;
        height:240px;
        background-color: #11366A;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-120px;
        margin-left:-200px;
        padding:20px;
        box-sizing:border-box;
        color:#fff;
    }
    .phone-list{
        width:100%;
        height:24px;
    }
    .phone-list+.phone-list{
        margin-top:20px;
    }
    .phone-list-title{
        width:120px;
        height: 100%;
        line-height:24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .phone-list-input{
        width:220px;
        height: 100%;
        box-sizing: border-box;
        border: 1px solid #ccc;
        outline: none;
        color:#bbc2d2;
        background-color:#1b4180;
    }
    .count{
        width:40px;
        height: 100%;
        line-height: 24px;
        text-align:center;
    }
    .code-btn{
        width: 100px;
        height: 100%;
        color:#fff;
        background-color:#0C5297;
        border:none;
        border-radius: 5px;
        outline: none;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .confirm-btn button{
        width: 160px;
        height: 100%;
        color:#fff;
        background-color:#0C5297;
        border:none;
        border-radius: 5px;
        outline: none;
        box-sizing: border-box;
        overflow:hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .code-btn:hover,.confirm-btn button:hover{
        background-color:#0193FF;
    }
    .getPwd-way-emile{
        height:242px;
        margin-top:-121px;
    }
</style>
<style scoped>
    @import '../assets/css/loginPop.css';  
</style>





// WEBPACK FOOTER //
// src/components/GetPwd.vue